import { useRecoilValue } from "recoil";
import { isApp } from "../../../../hooks/useNativeApp";
import { GameMainWrapper } from "../Style/GameStyles";
import { GameBanner } from "./GameBanner";
import { GameButtonSlide } from "./GameButtonSlide";
import { GameCategory } from "./GameCategory";
import { insetState } from "../../../../recoil/inset";

export const GameMain = () => {
  const inset = useRecoilValue(insetState);
  return (
    <GameMainWrapper isApp={inset}>
      <GameBanner></GameBanner>
      <GameCategory></GameCategory>
      <GameButtonSlide></GameButtonSlide>
    </GameMainWrapper>
  );
};
